export function triggerPreferencesDownload(
  anchor: HTMLAnchorElement,
  data: unknown,
) {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: "application/json",
  });
  const url = window.URL.createObjectURL(blob);
  anchor.href = url;
  anchor.download = `user-preferences-${new Date().toISOString().split("T")[0]}.json`;
  anchor.click();
  window.URL.revokeObjectURL(url);
}
